import { AppButton } from 'shared/UI/UIKit/Button';
import type { BellSchedule } from 'services/api';
import { useBellScheduleApply } from '../model';

interface BellScheduleApplyProps {
  bellSchedule: BellSchedule;
  refreshTable: () => void;
}

export const BellScheduleApply = ({ bellSchedule, refreshTable }: BellScheduleApplyProps) => {
  const {
    methods: { handleApplyBellSchedule },
  } = useBellScheduleApply({ bellSchedule, refreshTable });

  return (
    <AppButton type="primary" onClick={handleApplyBellSchedule}>
      Применить
    </AppButton>
  );
};
